import { ContentChildren, Directive, QueryList } from "@angular/core";
import { ListColumnDirective } from "./list-column.directive";

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "rask-list-custom-row"
})
export class ListCustomRowDirective {
    @ContentChildren(ListColumnDirective) columns: QueryList<ListColumnDirective>;
}
